import "./styles.less";

import Measure from "react-measure";
import { useImage } from "./Image.hook";
import { useEffect, useState } from "react";


const ImagenOptimizada = props => {
	const [dimensions, setdDimensions] = useState({
		width: 1,
		height: 1,
	});
	// INF-1813 — la caja más grande que se midió. `dimensions` se queda con la PRIMERA medida
	// porque alimenta los atributos width/height de la <img>, que participan del layout (en el
	// mosaico de la home, cambiarlos agranda la caja y re-dispara la medida). Pero dentro de un
	// carrusel esa primera medida es previa al layout (168×347 para una caja que termina en
	// 374×468), así que la foto se pide con ésta.
	const [largest, setLargest] = useState({ width: 1, height: 1 });

	const [errored, setErrored] = useState(false);

	const { getImagenOptimizada, getSrcSet } = useImage();

	useEffect(()=>{
		if(props.src){
			setErrored(false);
		}
		else{
			setErrored(true)
		}
	},[props.src])

	return (
		<Measure
			bounds
			onResize={contentRect => {
				//only first time rendering
				if (dimensions.width <= 1) {
					setdDimensions(contentRect.bounds);
				}
				// Se vuelve a pedir recién cuando la caja crece 100 px (si no, cada píxel que crece es una
				// URL y un fetch nuevos), y con la medida exacta, para no deformar la caja pedida.
				const { width, height } = contentRect.bounds;
				setLargest(prev => (width >= prev.width + 100 || height >= prev.height + 100)
					? { width, height }
					: prev);
			}}>
			{({ measureRef }) => {
				const white_pixel =
					"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8zwMAAhABDcCVldsAAAAASUVORK5CYII=";

				const width = typeof props.width === "number" ? props.width : Math.round(Math.max(props.minWidth ? props.minWidth : 1, dimensions.width))

				const height = typeof props.height === "number" ? props.height : Math.round(Math.max(props.minHeight ? props.minHeight : 1, dimensions.height))

				const fetchSize = {
					src: props.src,
					width: typeof props.width === "number" ? props.width : Math.round(Math.max(width, largest.width)),
					height: typeof props.height === "number" ? props.height : Math.round(Math.max(height, largest.height)),
					resize: props.resize,
				};
				const src = getImagenOptimizada(fetchSize);
				

				const imgProps = {
					src: (width>1 || height>1) ? src : white_pixel,
					srcSet: (width>1 || height>1) ? getSrcSet(fetchSize) : undefined,
					alt: width > 1 ? props.alt : "",
					width: width>1? width : null,
					height: height>1? height : null,
				};				

				for (const i in props) {
					if (["className", "width", "height", "style"].includes(i)) {
						imgProps[i] = props[i];
					}
				}

				if (errored) {
					imgProps.src =
						"https://cdn1.infocasas.com.uy/web/66575677eea43_screenshot-2024-05-29-at-11.20.20.png";
					imgProps.srcSet = undefined;
				}

				return (
					<>
						{props.backDrop && (
							<div
								className="back-drop"
								style={{ backgroundImage: `url(${imgProps.src})` }}
							/>
						)}
						<img
							ref={measureRef}
							{...imgProps}
							/* onError={() =>{!errored && setErrored({ ...dimensions, ...errored, errored: true })}}*/
						/>
						<style jsx>{`
							img {
								z-index: ${props.backDrop ? 2 : 0};
							}
						`}</style>
					</>
				);
			}}
		</Measure>
	);
};

export { ImagenOptimizada };
